<template>
  <div>
    <v-select
      outlined
      dense
      v-model="selectedNode.settings.credentialId"
      :items="filteredAuthentications"
      @change="(val) => onUpdate(val, 'settings.credentialId')"
      item-text="name"
      item-value="id"
      label="Select Integration"
      style="margin-bottom: 15px"
    ></v-select>
    <v-select
      outlined
      dense
      v-model="selectedNode.settings.action"
      :items="actionMethods"
      @change="(val) => onUpdate(val, 'settings.action')"
      item-text="label"
      item-value="value"
      :hint="hintText"
      label="Action"
      style="margin-bottom: 15px"
    ></v-select>
    <v-select
      outlined
      dense
      v-if="selectedNode.settings.action === 'set'"
      v-model="selectedNode.settings.valueToStore"
      :items="availableInputFields"
      @change="(val) => onUpdate(val, 'settings.valueToStore')"
      hint="Pass an object to be stored in the integration."
      item-text="name"
      item-value="name"
      label="Value To Store"
      style="margin-bottom: 15px"
    ></v-select>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers('workflows/details');
const { mapGetters: credentialsGetters } =
  createNamespacedHelpers('credentials');

export default {
  name: 'integrations-store',
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
    ...credentialsGetters({
      authentications: 'AUTHENTICATIONS',
    }),
    filteredAuthentications() {
      return this.authentications.filter((item) => {
        return item.credential_type === 'dynamic';
      });
    },
    hintText() {
      if (this.selectedNode.settings.action === 'set') {
        return 'Replace the values of this integration with the object to be stored.';
      } else if (this.selectedNode.settings.action === 'get') {
        return 'Get the values of this integration.';
      }
      return 'Select the integration you want to use or update.';
    },
  },
  props: {
    availableInputFields: { required: true },
  },
  data() {
    return {
      actionMethods: [
        {
          value: 'set',
          label: 'Store Content',
        },
        {
          value: 'get',
          label: 'Get Content',
        },
      ],
    };
  },
  methods: {
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
  },
};
</script>

<style scoped lang="scss"></style>
